import { findIndex, remove } from 'lodash';

import {
  getDefaultSchema,
  getCardsVariationSchema,
} from 'iovisit-theme/config';
import zoomSVG from '@plone/volto/icons/zoom.svg';
import fileSVG from '@plone/volto/icons/file.svg';
import ListDownloadFileView from 'iovisit-museum-theme/components/Blocks/ListDownloadFile/View';
import ListDownloadFileEdit from 'iovisit-museum-theme/components/Blocks/ListDownloadFile/Edit';
import SearchArtworksView from 'iovisit-museum-theme/components/Blocks/SearchArtworks/View';
import SearchArtworksEdit from 'iovisit-museum-theme/components/Blocks/SearchArtworks/Edit';

export const IoVisitMuseumBlocks = (config) => {
  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks,
    Room: ['title', 'text', 'listDownloadFile'],
    Artwork: ['title', 'text', 'listDownloadFile', 'multimediaFolderGallery'],
    Museum: ['title', 'text', 'listDownloadFile', 'contacts'],
    Event: [
      'title',
      'text',
      'listDownloadFile',
      'multimediaFolderGallery',
      'contacts',
    ],
  };

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    listDownloadFile: {
      //mostra (in formato lista) il contenuto della cartella Brochure presente fra gli items del ct
      id: 'listDownloadFile',
      title: 'List Download File',
      icon: fileSVG,
      group: 'media',
      view: ListDownloadFileView,
      edit: ListDownloadFileEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    searchArtworks: {
      id: 'searchArtworks',
      title: 'Ricerca opere',
      icon: zoomSVG,
      group: 'search',
      view: SearchArtworksView,
      edit: SearchArtworksEdit,
      restricted: false,
      mostUsed: true,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
  };

  config.blocks.blocksConfig.listing.variations[
    findIndex(config.blocks.blocksConfig.listing.variations, (o) => {
      return o.id === 'cards';
    })
  ].schemaEnhancer = ({ schema, formData, intl }) => {
    let pos = getDefaultSchema(schema, formData, intl);
    getCardsVariationSchema(schema, formData, intl, pos);
    delete schema.properties.show_thematic_area;

    remove(
      schema.fieldsets[findIndex(schema.fieldsets, (o) => o.id === 'default')]
        .fields,
      (o) => o === 'show_thematic_area',
    );

    return schema;
  };

  delete config.blocks.blocksConfig.searchStrutturaRicettiva; //rimosso perchè non servere per i musei
};
